import { Component } from '@angular/core';
import {Events, IonicPage, Loading, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ApiForumProvider} from "../../providers/api-forum/api-forum";
import {AppForumTopicResponsePage} from "../app-forum-topic-response/app-forum-topic-response";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {AppForumTopicCreatePage} from "../app-forum-topic-create/app-forum-topic-create";

/**
 * Generated class for the AppForumPostsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-forum-posts',
  templateUrl: 'app-forum-posts.html',
})
export class AppForumPostsPage {

  private postsList: any[];
  private topic: any;
  private forum: any;

  public responsePage: any = AppForumTopicResponsePage;

  public editAvailable: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public apiForum: ApiForumProvider, public loaderCtrl: LoadingController, public events: Events, public userState: UserStateProvider) {
    console.log("constructor of AppForumPostsPage", this.navParams)
    this.topic = this.navParams.data.topic;
    this.forum = this.navParams.data.forum;
  }

  private loader: Loading;

  ionViewWillLoad() {
    this.loader = this.loaderCtrl.create();
    this.loader.present();


  }

  ionViewDidLoad() {
    this.apiForum.getForumPosts(this.topic.id).then(data => {
      this.postsList = data;
      this.loader.dismissAll();

      this.editAvailable = (this.topic.authorId == this.userState.user.id)

      this.topic.posts = this.postsList;

      this.events.publish('forum:topicViewed', {id: this.topic.id})
    })
  }

  editTopic(topic) {
    this.navCtrl.push(AppForumTopicCreatePage, {topic: topic, forum: this.forum});
  }

  editPost(post) {
    this.navCtrl.push(AppForumTopicResponsePage, {topic: this.topic, forum: this.forum, post: post});
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-forum-posts/app-forum-posts.ts